// extracted by mini-css-extract-plugin
export default {"container":"organization-cities_container__W2RI7","header":"organization-cities_header__ilrs0"};